<template>
  <editor :id="id" default-tab="channel" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Channel from './editor/Channel'
import Instance from './editor/Instance'
import Stats from './editor/Stats'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Channel",      name: "channel",      component: Channel},
        {title: "Instance",     name: "instance",     component: Instance, edit_only: true, admin_only: true},
        {title: "Stats",        name: "stats",        component: Stats, admin_only: true}
      ]
    }
  }
}
</script>
